module.exports = __webpack_public_path__ + "img/contributionGreen.96b4bb74.png";